const bootstrap = import('./boostrap')

export default bootstrap